//Vendor
import gsap from 'gsap'
import axios from 'axios'
import { format } from 'date-fns'
import frLocale from 'date-fns/locale/fr'
import { Observer } from 'gsap/Observer'
gsap.registerPlugin(Observer)
import Swiper from 'swiper'
//Custom
import Form from 'Scripts/components/Form'
import Title from 'Scripts/animations/Title'
import Image from 'Scripts/animations/Image'
import Paragraph from 'Scripts/animations/Paragraph'
import Transition from 'Scripts/animations/Transition'

import {
  getEmbeddedFeaturedImg,
  getEmbeddedTerm,
  getEmbeddedPost,
  getEmbeddedGallery,
} from 'Scripts/utils/wordpress'
import Lines from 'Scripts/components/Lines'
import { getCookieValue } from 'Scripts/utils/utils'
import { dataByLang } from 'Scripts/utils/lang'

export default class {
  constructor({ selector, scroller }) {
    this.selector =
      selector instanceof window.HTMLElement ? selector : document.querySelectorAll(selector)
    this.scroller = scroller || null

    this.modal = {}
    this.formTL = gsap.timeline()
    this.loadNextPost = this.loadNextPost.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.lang = getCookieValue('wp-wpml_current_language') || 'fr'
    this.submission = false
    //Methods
    this.initVar()
    this.disable()
    this.enable()
  }

  enable() {
    this.selector.forEach((el) => {
      el.addEventListener('click', async (e) => {
        e.preventDefault()

        //Disable body default scroll
        document.querySelector('body').style.overflowY = 'hidden'
        //Save modal data in object
        this.modal = {
          modal: `#${el.dataset.modal}`,
          postType: el.dataset.module,
          dom: document.querySelector(`#${el.dataset.modal}.single`),
          btnback: document.querySelector(`#${el.dataset.modal} .single__btn_back`),
          container: document.querySelector(`#${el.dataset.modal} .single__wrapper`),
          loaderHeight: 0,
        }

        let wrapper = `#${el.dataset.modal}`
        let postId = el.dataset.id
        //Get Data
        postId && (await this.getData(postId))
        //reinitComponents
        this.initSlider(wrapper)
        this.lines()
        this.share()
        //history
        this.previousURL = window.location.href
        this.previousURL = this.previousURL.replace(/\/$/, '')
        this.slug = this.modal.data?.slug
        this.isSingle = this.previousURL.includes(this.slug)
        !this.isSingle && this.slug && history.pushState({}, '', `${this.previousURL}/${this.slug}`)

        if (this.modal.postType == 'emplois') {
          // this.submitForm()
        }

        if (this.modal.postType == 'posts' || this.modal.postType == 'projets') {
          this.initNextPostTrigger()
        }
        //Animation
        const tl = gsap.timeline({
          delay: 0,
          onComplete: () => {
            //Stop propagation to lenis smooth scroll
            this.disableLenis()

            //Animations
            setTimeout(this.animateIn(), 500)
          },
        })

        tl.to(wrapper, { autoAlpha: 1 })
        tl.to(`${wrapper} .single__wrapper`, { left: 0, duration: 1, ease: 'Circ.easeOut' })
        tl.to(`${wrapper} .single__btn_back`, { autoAlpha: 1, duration: 0.2, ease: 'Circ.easeOut' })
      })
    })
  }

  disable() {
    document.querySelectorAll('.single')?.forEach((el) => {
      el.querySelector('.single__btn_back')?.addEventListener('click', (e) => {
        e.preventDefault()
        //
        if (document.documentElement.classList.contains('isTouchDevice')) {
          document.querySelector('body').style.WebkitOverflowScrolling = 'touch'
        }
        document.querySelector('body').style.overflowY = 'scroll'

        //
        const tl = gsap.timeline({
          delay: 0,
          onComplete: () => {
            this.modal.container &&
              this.modal.container.removeEventListener('scroll', this.onScroll, { passive: true })
            this.modal = {}
            //Animations
            this.animateOut()
            //history
            history.replaceState({}, '', this.previousURL)
          },
        })

        tl.to(this.modal.btnback, {
          autoAlpha: 0,
          duration: 0.5,
          ease: 'Expo.easeOut',
        })
          .to(this.modal.container, {
            left: '100%',
            duration: 1,
            ease: 'Expo.easeOut',
          })
          .to(el, {
            autoAlpha: 0,
          })
      })
    })
  }

  animateIn(wrapper) {
    this.animations = []
    //Titles
    wrapper = wrapper || this.modal.container
    // console.log(wrapper)

    this.titles = wrapper.querySelectorAll('[data-animate="title"]')
    if (this.titles) {
      this.titlesAnimation = gsap.utils
        .toArray(this.titles)
        .map((title) => new Title({ element: title }))
      this.animations.push(...this.titlesAnimation)
    }

    //Images
    this.images = wrapper.querySelectorAll('[data-animate="image"]')
    if (this.images) {
      this.imagesAnimation = gsap.utils
        .toArray(this.images)
        .map((img) => new Image({ element: img }))
      this.animations.push(...this.imagesAnimation)
    }

    //Paragraphs
    this.paragraphs = wrapper.querySelectorAll('[data-animate="paragraph"]')
    if (this.paragraphs) {
      this.paragraphsAnimation = gsap.utils
        .toArray(this.paragraphs)
        .map((paragraph) => new Paragraph({ element: paragraph }))
      this.animations.push(...this.paragraphsAnimation)
    }

    //Transition
    this.transitions = wrapper.querySelectorAll('[data-animate="reveal"]')
    if (this.transitions) {
      this.transitionsAnimation = gsap.utils
        .toArray(this.transitions)
        .map((transition) => new Transition({ element: transition }))
      this.animations.push(...this.transitionsAnimation)
    }
  }

  animateOut() {
    this.animations?.forEach((obj) => {
      // console.log(obj.elements)
      obj.deleteObserver()
      obj.elements && obj.elements?.text?.revert()
    })
  }

  lines() {
    return new Lines({
      selector: `${this.modal.modal}.single .lines`,
      wrapper: `${this.modal.modal}.single .single__wrapper`,
    })
  }

  initSlider(wrapper, update) {
    wrapper = wrapper || this.modal.modal
    update = update || false

    const slider = document.querySelector(`${wrapper} .single__slider`)
    if (!slider) return
    //destroy swiper
    update && this.swiper?.destroy()
    //init swiper
    this.swiper = new Swiper(`${wrapper} .single__slider`, {
      loop: true,
      speed: 1000,
      observer: true,
      pagination: {
        el: `${wrapper} .single__slider_pagination`,
        type: 'fraction',
      },
      navigation: {
        nextEl: `${wrapper} .single__slider_next`,
        prevEl: `${wrapper} .single__slider_prev`,
      },
      // grabCursor: false,
      // watchSlidesProgress: true,
      // mousewheelControl: false,
      // keyboardControl: false
    })

    //update swiper
    update && this.swiper?.update()
  }

  async getData(postId, nextElement = '') {
    let newSpan = ''
    if (this.modal.postType === 'projets') {
      newSpan = document.createElement('span')
      newSpan.textContent = dataByLang[this.lang]?.projet
      newSpan.classList.add('single__descriptif_title')
    }

    this.modal.postId = postId
    this.modal.container = document.querySelector(
      `${this.modal.modal} .single__wrapper${nextElement}`
    )
    this.modal.share = document.querySelectorAll(
      `${this.modal.modal} ${nextElement} .share__wrapper a`
    )
    this.modal.footer = document.querySelector(`${this.modal.modal} ${nextElement} .single__footer`)

    this.modal.roll = document.querySelector(`${this.modal.modal} ${nextElement} .roll__wrapper`)
    this.modal.loader = document.querySelector(
      `${this.modal.modal} ${nextElement} .single__footer_loader`
    )
    this.modal.footerTitle = document.querySelector(
      `${this.modal.modal} ${nextElement} .single__footer_title`
    )

    // console.log(`${process.env.API}/${this.modal.postType}/${postId}?_embed`)

    // await axios.get(`${process.env.API}/${this.modal.postType}/${postId}?_embed`)
    await axios({
      method: 'get',
      url: `${process.env.SGTMAPI}/proxy`,
      params: {
        endpoint: this.modal.postType,
        id: postId,
        lang: this.lang,
        _embed: true,
      },
    })
      .then(async ({ data }) => {
        // console.log(data)
        let galleryItems = ''
        this.modal.data = data
        // let next = data.next ? data.next : data.previous
        // let next = data.next ? data.next : null
        this.next = null
        const localData = JSON.parse(localStorage.getItem(this.modal.postType))
        const localDataLength = localData?.length
        //get next post in array order from localstorage by using postId
        localDataLength &&
          localData?.forEach((post, index) => {
            if (post.id === parseInt(postId) && index < localDataLength - 1) {
              this.next = localData[index + 1]
            }
          })
        // console.log(this.next)
        if (this.next) {
          this.modal.nextPost = this.next.id
          if (this.modal.roll) this.modal.roll.style.display = 'initial'
          if (this.modal.footer) this.modal.footer.style.display = 'flex'
          //
          this.modal.footer?.addEventListener('click', this.onClick.bind(this))
        } else {
          if (this.modal.roll) this.modal.roll.style.display = 'none'
          if (this.modal.footer) this.modal.footer.style.display = 'none'
        }
        switch (this.modal.postType) {
          case 'posts':
            document.querySelector(`${this.modal.modal} ${nextElement} .single__img`).src =
              await getEmbeddedFeaturedImg(data._embedded)
            document.querySelector(`${this.modal.modal} ${nextElement} .single__title`).innerHTML =
              data.title.rendered
            document.querySelector(
              `${this.modal.modal} ${nextElement} .date`
            ).innerHTML = `${format(new Date(data.date), 'dd MMMM yyyy', { locale: frLocale })}`
            document.querySelector(`${this.modal.modal} ${nextElement} .single__cat`).innerHTML =
              await getEmbeddedTerm(data._embedded)
            document.querySelector(
              `${this.modal.modal} ${nextElement} .single__descriptif`
            ).innerHTML = data.content.rendered
            document.querySelector(
              `${this.modal.modal} ${nextElement} .single__accroche`
            ).innerHTML = data.acf.accroche
            if (this.next) {
              this.modal.footer.dataset.id = this.next.id
              this.modal.footerTitle.innerHTML = this.next.title
              document.querySelector(
                `${this.modal.modal} ${nextElement} .single__footer_img img`
              ).src = this.next.featuredimg
              this.modal.footerMaxHeight = this.modal.footer.offsetHeight
            }
            break

          case 'emplois':
            document.querySelector(`${this.modal.modal} .single__title`).innerHTML =
              data.title.rendered
            document.querySelector(`${this.modal.modal} .date`).innerHTML = `${format(
              new Date(data.date),
              'dd MMMM yyyy',
              { locale: frLocale }
            )}`
            document.querySelector(`${this.modal.modal} .single__descriptif`).innerHTML =
              data.content.rendered
            document.querySelector(`${this.modal.modal} .dispo__wrapper .badge`).innerHTML =
              data.acf.disponibilite
            break

          case 'projets':
            // get gallery
            this.galleryArray = await getEmbeddedGallery(data._embedded, data.acf.galerie)
            this.galleryArray.length &&
              this.galleryArray.forEach((img) => {
                galleryItems += `<div class="single__slider_item swiper-slide"><img class="cover" src="${img}"></div>`
              })
            document.querySelector(
              `${this.modal.modal} ${nextElement} .single__slider .swiper-wrapper`
            ).innerHTML = galleryItems
            document.querySelector(`${this.modal.modal} ${nextElement} .single__title`).innerHTML =
              data.title.rendered
            document.querySelector(`${this.modal.modal} ${nextElement} .date`).innerHTML =
              data.acf.date
            // document.querySelector(`${this.modal.modal} ${nextElement} .client`).innerHTML = await getEmbeddedPost(data._embedded, data.acf.client)
            document.querySelector(`${this.modal.modal} ${nextElement} .client`).innerHTML =
              data.acf.client
            document.querySelector(`${this.modal.modal} ${nextElement} .single__metier`).innerHTML =
              await getEmbeddedPost(data._embedded, data.acf.metier)
            document.querySelector(`${this.modal.modal} ${nextElement} .single__cat`).innerHTML =
              await getEmbeddedTerm(data._embedded)
            document.querySelector(
              `${this.modal.modal} ${nextElement} .single__descriptif`
            ).innerHTML = data.content.rendered
            // document.querySelector(`${this.modal.modal} ${nextElement} .single__descriptif`).innerHTML = `<div>${data.acf.descriptif}</div>`
            document
              .querySelector(`${this.modal.modal} ${nextElement} .single__descriptif`)
              .firstChild.prepend(newSpan)
            document.querySelector(`${this.modal.modal} ${nextElement} .single__meta`).innerHTML =
              data.acf.chantier_en_chiffres
                .map(
                  (elm) =>
                    `<div class="single__meta_item"> <span> ${elm.chiffre} <i>${elm.unite}</i></span><span> ${elm.suffix}</span></div>`
                )
                .join('')

            if (this.next) {
              this.modal.footer.dataset.id = this.next.id
              this.modal.footerTitle.innerHTML = this.next.title
              document.querySelector(
                `${this.modal.modal} ${nextElement} .single__footer_img img`
              ).src = this.next.featuredimg
              this.modal.footerMaxHeight = this.modal.footer.offsetHeight
            }

            break
          default:
            document.querySelector('#modal_pages .modal__title').innerHTML = data.title.rendered
          // document.querySelector('#modal_pages .modal__content').innerHTML = data.content.rendered
        }
      })
      .catch(function (error) {
        console.log(error?.message)
      })
  }

  share() {
    const shareLink = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
      twitter: 'https://twitter.com/intent/tweet?text=',
    }
    this.modal.share &&
      this.modal.share.forEach((elm) => {
        elm.addEventListener('click', (e) => {
          e.preventDefault()
          window.open(shareLink[elm.dataset.rs] + this.modal.data.link, '_blank')
        })
      })
  }

  submitForm() {
    if (this.form) {
      gsap.set(this.form.container.parentNode, { autoAlpha: 1, y: 0 })
      gsap.set(this.form.container, { display: 'grid' })
      gsap.set('.form__msg', { autoAlpha: 0, display: 'none' })
      window.dispatchEvent(new Event('resize'))
    }
    gsap.set('.form__msg', {
      autoAlpha: 0,
      display: 'none',
    })
    // console.log(this.modal.modal)
    this.form = new Form({
      form: `${this.modal.modal} .form__wrapper`,
      fields: {
        nom: `${this.modal.modal} #nom`,
        prenom: `${this.modal.modal} #prenom`,
        email: `${this.modal.modal} #email`,
        telephone: `${this.modal.modal} #telephone`,
        linkedin: `${this.modal.modal} #linkedin`,
        cv: `${this.modal.modal} #cv`,
        lm: `${this.modal.modal} #lm`,
      },
      submit: `${this.modal.modal} #submit`,
    })

    //Bind Event
    this.form.container.addEventListener('submitform', () => this.onSubmit(), false)
  }

  async onSubmit() {
    if (this.submission) return
    this.submission = true
    document.querySelector(`${this.modal.modal} #submit`).disabled = true
    document.querySelector(`${this.modal.modal} #submit`).style.opacity = '0.6'
    // this.modal.modal = true
    //
    this.acf = {}
    for (const [key, field] of this.form.formData.entries()) {
      this.acf[key] = field
    }
    this.modal.data && (this.acf['annonce_associee'] = this.modal.data.id)

    // axios({
    //   method: 'post',
    //   // url: `${process.env.API}/candidature/`,
    //   url: `${process.env.SGTMAPI}/addcandidature/`,
    //   data: {
    //     title: `${this.acf['nom']} ${this.acf['prenom']}`,
    //     status: 'publish',
    //     acf: this.acf,
    //   },
    // })
    axios({
      method: 'post',
      url: `${process.env.SGTMAPI}/proxy`, // On passe par le proxy
      data: {
        endpoint: 'candidature', // Le proxy saura vers quel endpoint relayer
        data: {
          title: `${this.acf['nom']} ${this.acf['prenom']}`,
          status: 'publish',
          acf: this.acf,
        },
      },
    }).then((response) => {
      this.sendMail()

      this.formTL
        .to(this.form.container.parentNode, {
          autoAlpha: 0,
          y: 150,
          duration: 1,
          onComplete: () => {
            // this.form.container.parentNode.remove()
            gsap.set(this.form.container, { display: 'none' })
            // this.form = {}
            window.dispatchEvent(new Event('resize', { cancelable: true }))
          },
        })
        .fromTo(
          '.form__msg',
          {
            y: 150,
          },
          {
            autoAlpha: 1,
            display: 'block',
            y: 0,
            duration: 1,
          }
        )
    })
  }

  async sendMail() {
    // await axios({
    //   method: 'post',
    //   url: `${process.env.API}/sendemail/`,
    //   data: {
    //     form: 'candidature',
    //     subject: 'Candidature',
    //     data: this.acf,
    //   },
    // })
    //   .then((response) => {
    //     // console.log(response.data)
    //   })
    //   .catch((error) => {
    //     console.log(error.message)
    //   })
  }

  initNextPostTrigger() {
    //
    if (this.modal.container) {
      this.modal.container.removeEventListener('wheel', this.loadNextPost, { passive: true })
      this.modal.container.removeEventListener('scroll', this.onScroll, { passive: true })
      //

      this.modal.container.addEventListener('scroll', this.onScroll, { passive: true })
    }
  }

  onScroll(e) {
    if (!this.next) return
    // if (e.target.scrollTop >= e.target.scrollTopMax) {
    if (e.target.scrollTop >= e.target.scrollHeight - window.innerHeight) {
      setTimeout(() => {
        this.modal.container &&
          this.modal.container.addEventListener('wheel', this.loadNextPost, true, { passive: true })
      }, 500)
    } else {
      this.modal.loaderHeight = 0
      this.isHalfway = false

      //gsap.to(this.modal.loader, {
      //   height: 0,
      //   duration: 1,
      //   onComplete: () => {
      //     this.modal.loaderHeight = 0
      //     this.isHalfway = false
      //     // this.postCloned = false
      //   }
      // })
      this.modal.container &&
        this.modal.container.removeEventListener('wheel', this.loadNextPost, { passive: true })
    }
  }

  onClick() {
    this.clonePage()
    // this.loadPage()
    gsap.to(this.modal.loader, {
      height: this.modal.footerMaxHeight,
      onComplete: () => {
        this.loadPage()
      },
    })
  }

  async loadNextPost(event) {
    // const MaxHeight = this.modal.footerMaxHeight

    //
    this.modal.loaderHeight += event.wheelDeltaY * -0.1
    this.modal.loaderHeight = Math.min(this.modal.loaderHeight, this.modal.footerMaxHeight)
    //
    let percent = Math.round((this.modal.loaderHeight * 100) / this.modal.footerMaxHeight)
    //Animation
    gsap.to(this.modal.loader, {
      height: this.modal.loaderHeight,
      delay: 0,
      ease: 'none',
    })
    //Logique
    // à 50% : il faut changer la couleur du titre
    if (percent >= 45 && !this.isHalfway) {
      this.isHalfway = true
      gsap.to(this.modal.footerTitle, {
        color: 'white',
      })
      //Préparation les donnée de l'article suivant
      this.clonePage()
    }
    // à 100% Il faut activer le nouveau article
    else if (percent >= 100) {
      this.loadPage()
    }
    // this.modal.loader.style.height = `${this.modal.loaderHeight}px`
  }

  initVar() {
    this.isHalfway = false
    this.postCloned = false
    this.goToNext = false
    this.nextPostLoaded = false
    this.galleryArray = []
  }

  clonePage() {
    if (!this.postCloned) {
      //
      const nextPostNode = this.modal.container.cloneNode(true)
      nextPostNode.classList.add('next')
      nextPostNode.style.top = '100%'
      this.modal.container.classList.add('prev')
      this.modal.prevPostNode = this.modal.container
      this.modal.nextPostNode = this.modal.dom.appendChild(nextPostNode)
      this.postCloned = true
    }
  }

  async loadPage() {
    if (this.postCloned && !this.goToNext) {
      this.goToNext = true
      const tl = gsap.timeline()

      this.modal.prevPostNode.removeEventListener('scroll', this.onScroll, { passive: true })
      this.modal.container.removeEventListener('wheel', this.loadNextPost, { passive: true })

      await this.getData(this.modal.nextPost, `.next`).then(() => {
        this.nextPostLoaded = true
        //Animations
        this.animateIn(this.modal.nextPostNode)
        //Init new slider

        this.initSlider('.next', true)
        //
        tl.to(
          this.modal.prevPostNode,
          {
            top: '-100%',
            delay: 1,
            duration: 1.5,
            ease: 'power2.inOut',
          },
          0
        )

        tl.to(
          this.modal.nextPostNode,
          {
            top: '0%',
            delay: 1,
            duration: 1.5,
            ease: 'power2.inOut',
            onComplete: () => {
              //remove previous dom element
              this.modal.prevPostNode.remove()
              this.modal.prevPostNode = null
              this.modal.container.classList.remove('next')
              //Reinit variables
              this.modal.loader.style.height = '0px'
              this.modal.loaderHeight = 0
              this.initVar()
              //reinit components
              this.lines()
              this.share()
              this.initNextPostTrigger()
              this.disableLenis()
              //Update url
              //get pathname
              const pathname = window.location.pathname
              //get slug
              const slug = this.modal.data.slug
              //replace slug
              const newUrl = pathname.replace(/\/[^\/]*$/, `/${slug}`)
              //replace url
              history.replaceState({}, '', newUrl)
            },
          },
          0
        )
      })
    }
  }

  disableLenis() {
    //Stop propagation to lenis smooth scroll
    this.modal.container.addEventListener(
      'wheel',
      (e) => {
        e.stopPropagation()
      },
      true
    )
  }
}
